
define('text!templates/modules/profile/personal-content.html',[],function () { return '<div class="panel-body settings">\n    <div id="setting-personal-info"></div>\n    <div id="setting-preferences"></div>\n</div>\n';});

